<template>
  <!-- 提货列表 -->
  <div class="pickUp-list">
    <ab-list-query :tabs="tabs" @handleTabs="handleTabs">
      <template #right>
        <el-row :gutter="20">
          <el-col :span="4">
            <el-input
              placeholder="提货单号"
              v-model.trim="formSearch.number"
              clearable
            >
            </el-input>
          </el-col>
          <el-col :span="4">
            <el-select
              v-model="formSearch.status"
              placeholder="单据状态"
              clearable
              @change="searchForm"
            >
              <el-option label="待提交" value="1"></el-option>
              <el-option label="待审核" value="2"></el-option>
              <el-option label="待安排" value="3"></el-option>
              <el-option label="已安排" value="4"></el-option>
              <el-option label="已取消" value="5"></el-option>
            </el-select>
          </el-col>
          <el-col :span="4">
            <ab-timeSearch
              class="searchBox"
              startSrc="提货时间起"
              endSrc="提货时间止"
              v-model="formSearch.queryDateArray"
              @searchEvent="queryDateChange"
            ></ab-timeSearch>
          </el-col>
          <el-col
            :span="4"
            class="text-left"
          >
            <el-button @click="searchForm">搜索</el-button>
            <el-button
              link
              class="btn-svg"
              @click="resetForm"
            >
              <ab-svg name="qingchu"></ab-svg>清除
            </el-button>
          </el-col>
        </el-row>
      </template>

      <template #toolbar>
        <el-button
          type="primary"
          @click="newPage()"
        >我要提货</el-button>

        <el-button
          :loading="loading.cancel"
          :disabled="cancelDis"
          @click="cancelPickUp"
        >取消提货</el-button>

        <el-button
          :loading="loading.delete"
          :disabled="multiSelected.length === 0 || deleteDis"
          @click="deleteItem"
        >删除</el-button>

        <el-button
          :loading="loading.export"
          @click="exportFile"
        >导出</el-button>
      </template>

      <template #table>
        <ab-table
          class="materialTable"
          ref="table"
          stripe
          showEdit
          showSelection
          selectionWidth="45"
          indexWidth="50"
          widths="100"
          isFilter="operator"
          :column-list="columns"
          :table-list="tableData"
          :dataListLoading="loading.table"
          :handleSelectionChange="selectionChange"
          :filterArry="['创建人', '确认人', '创建时间']"
          @filterColumns="filterColumns"
        >

          <template #driverCarType="scope">
            {{ getDriverCarTypeDesc(scope.row.driverCarType) }}
          </template>

          <template #statusDesc="scope">
            <span :class="getStatusClass(scope.row.status)"></span>
            {{ scope.row.statusDesc }}
          </template>

          <template #operator="scope">
            <el-button
              type="primary"
              link
              @click="getDetail(scope.row)"
            >{{scope.row.status == 1 ? '编辑' : '详情'}}</el-button>
          </template>
        </ab-table>
      </template>

      <template #page>
        <ab-page
          :pageTotal="page.total"
          :currentPage='page.currentPage'
          :pageSize="page.pageSize"
          :pageSizes="page.pageSizes"
          @searchForm="pageSearch"
        ></ab-page>
      </template>
    </ab-list-query>
  </div>
</template>

<script>
export default {
  name: 'pickUp-list',
  data() {
    return {
      tabs: [
        { name: '全部', value: '', state: '' },
        { name: '待提交', value: '', state: '1' },
        { name: '进行中', value: '', state: '2' },
        { name: '已完成', value: '', state: '3' }
      ],
      activedName: '',
      options: {},
      loading: {
        table: false,
        cancel: false,
        delete: false,
        export: false
      },
      formSearch: {},
      columns: [
        {
          props: 'number',
          labels: '提货单号',
          widths: 140
        },
        {
          props: 'statusDesc',
          labels: '单据状态',
          widths: 90,
          slot: 'slot'
        },
        {
          props: 'custOrderNo',
          labels: '订单编号',
          widths: 160
        },
        {
          props: 'deliveryTime',
          labels: '提货时间',
          widths: 160
        },
        {
          props: 'logicTypeDesc',
          labels: '用车需求',
          widths: 100,
        },
        {
          props: 'driverCarType',
          labels: '车柜型',
          widths: 80,
          slot: 'slot'
        },
        {
          props: 'cardBoard',
          labels: '卡板数',
          widths: 80
        },
        {
          props: 'packedQty',
          labels: '件数',
          widths: 80
        },
        {
          props: 'addressContentDesc',
          labels: '提货地址',
          widths: 180
        },
        {
          props: 'createByNameDesc',
          labels: '创建人',
          widths: 80
        },
        {
          props: 'submitManIdDesc',
          labels: '确认人',
          widths: 80
        },
        {
          props: 'createTime',
          labels: '创建时间',
          widths: 160
        }
      ],
      //列表数据
      tableData: [],
      // 勾选行
      multiSelected: [],
      page: {
        currentPage: 1,
        pageSize: 10,
        pageSizes: [10, 20, 50, 100],
        total: 0
      }
    }
  },

  computed: {
    cancelDis() {
      if (this.multiSelected.length === 0 || this.multiSelected.length > 1) {
        return true
      } else {
        return !(this.multiSelected[0].status == 4)
      }
    },

    deleteDis() {
      for (let row of this.multiSelected) {
        if (row.status != 1) {
          return true
        }
      }
      return false
    },
    bizTypeNow: {
        get() {
            return (
                this.$store.state.bizTypeNow 
            )
        }
    },
  },
  

  created() {
    this.getSelectList()
  },
  activated () {
    this.searchForm()
  },
  methods: {
    handleTabs(item) {
      this.activedName = item
      this.searchForm()
    },

    getSelectList() {
      this.$get('/sys/dictData/getByTypes', {
        typeNumbers: 'transportType,carType'
      }).then(({ data }) => {
        if (data && data.code === 'C0000') {
          this.options = data.result
        } else {
          this.options = {}
        }
      })
    },

    // 创建日期
    queryDateChange(value) {
      if (value) {
        this.formSearch.queryBeginDate = value[0]
        this.formSearch.queryEndDate = value[1]
      } else {
        this.formSearch.queryBeginDate = ''
        this.formSearch.queryEndDate = ''
      }
      this.searchForm()
    },

    filterColumns(array) {
      this.columns = array
    },

    searchForm() {
      this.page.currentPage = 1
      this.getDataList()
    },

    resetForm() {
      this.formSearch = {}
    },

    pageSearch(obj) {
      this.page.currentPage = obj.currentPage
      this.page.pageSize = obj.pageSize
      this.getDataList()
    },

    getDataList() {

      let params = Object.assign({}, this.formSearch)
      params.sourceType = '2'
      params.deliveryNoticeStatusChoice = this.activedName
      params.bizTypeList = ['01', '02', '11']

      let bizTypes = this.$utils.getSessionStorage('bizType') || {}
      if (bizTypes.activeIndex == '01') {
        params.bizTypeList = ['01', '02', '11']
      }else{
        params.bizTypeList = ['03', '04', '06']
      }
      this.$post('/tms/deliveryNotice/list', {
        data: params,
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize
      }, this.loading, 'table').then(({ data }) => {
        if (data && data.code === 'C0000') {
          this.tableData = data.result.list
          this.page.total = data.result.total
          this.tabs.forEach(e => {
            if (e.name === '待提交') {
              e.value = data.extra && data.extra.waitSubmitCount || 0
            } else if (e.name === '进行中') {
              e.value = data.extra && data.extra.inProgressCount || 0
            }
          })
        }
      })
    },

    selectionChange(array) {
      this.multiSelected = array
    },

    // 单据状态class
    getStatusClass(value) {
      if (value == '1') {
        // 已保存
        return 'status-E21010'
      } else if (value == '2') {
        // 待审核
        return 'status-13227A'
      } else if (value == '3') {
        // 待安排
        return 'status-1165D4'
      } else if (value == '4') {
        // 已安排
        return 'status-0AB2A8'
      } else if (value == '5') {
        // 已取消
        return 'status-B1B1B1'
      } else {
        return ''
      }
    },

    getDriverCarTypeDesc(type) {
      if (this.options.carType && this.options.carType.length) {
        const find = this.options.carType.find(e => e.value === type)
        return find ? find.label : ''
      }
      return ''
    },

    // 我要提货
    newPage() {
      this.$router.push({
        path: '/pickUp-detail',
        query: {
          action: 'add',
          cache: false
        }
      })
    },

    // 取消提货
    cancelPickUp() {
      this.$prompt('此单已订车，若取消将产生返空费，仍需取消？仍需取消，请填写原因！', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputErrorMessage: '请输入取消原因',
        type: 'error',
        center: true
      }).then(({ value }) => {
        if (!value) {
          this.$message({
            type: 'waring',
            message: '请输入取消提货原因',
            offset: 380,
            grouping: true
          })
          return
        }
        this.$post('/tms/deliveryNotice/cancelDelivery', {
          id: this.multiSelected[0].id,
          cancelReason: value
        }, this.loading, 'cancel').then(({ data }) => {
          if (data && data.code === 'C0000') {
            this.$message({
              type: 'success',
              message: data.message,
              offset: 380,
              grouping: true
            })
            this.getDataList()
          }
        })
      }).catch(() => { })
    },

    //删除
    deleteItem() {
      this.$confirm(`确认删除该条数据吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        this.$post('/tms/deliveryNotice/del', {
          ids: this.multiSelected.map(e => e.id)
        }, this.loading, 'delete').then(({ data }) => {
          if (data && data.code === 'C0000') {
            this.$message({
              type: 'success',
              message: data.message,
              offset: 380,
              grouping: true
            })
            this.searchForm()
          }
        })
      }).catch(() => {})
    },

    // 导出
    exportFile() {
      let params = {data: Object.assign({}, this.formSearch)}
      params.deliveryNoticeStatusChoice = this.activedName

        let bizTypes = this.$utils.getSessionStorage('bizType') || {}
        if(bizTypes.activeIndex == '01') {
            params.bizTypeList = ['01', '02', '11']
        }else{
            params.bizTypeList = ['03', '04', '06']
        }
      this.$post('/tms/deliveryNotice/expList', {
        data: params,
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize,
        excelField: this.columns.map(e=>e.props)
      }, this.loading, 'export').then(({ data }) => {
        if (data && data.code === 'C0000') {
          // 创建隐藏的可下载链接
          var eleLink = document.createElement('a')
          eleLink.download = ''
          eleLink.style.display = 'none'
          // 字符内容转变成blob地址
          eleLink.href = data.result
          // 触发点击
          document.body.appendChild(eleLink)
          eleLink.click()
          // 然后移除
          document.body.removeChild(eleLink)
        }
      })
    },

    // 详情
    getDetail(row) {
      this.$router.push({
        path: '/pickUp-detail',
        query: {
          action: [1].includes(row.status) ? 'edit' : 'view',
          id: row.id
        }
      })
    }
  }
}
</script>

<style lang="scss">
.pickUp-list {
  .el-table-fixed-column--right {
    .el-button + .el-button {
      position: relative;
      margin-left: 14px !important;
      &::before {
        content: '';
        position: absolute;
        left: -8px;
        top: 4px;
        width: 1px;
        height: 10px;
        background: #bfbfbf;
      }
    }
  }
}
</style>
